<template>
  <div class="doc-list">
    <div class="doc-list-item" v-for="(item,index) in docList" :key="index" @click="itemClick(item)">
      <div class="doc_avatar">
        <img :src="item.head_img_url | imgFilter" v-if="item.head_img_url" />
        <img src="/static/icon/doc_avatar.png" v-else />
      </div>
      <div class="info-box">
        <div class="info-box-top">
          <div class="info-name">{{ item.name }}</div>
          <div class="info-status">{{ item.can_order? '可预约':'暂无号' }}</div>
        </div>
        <div class="info-title">{{ item.doctor_title }}</div>
        <div class="info-sc" >{{ '擅长:' + truncateRichText(item.speciality ? item.speciality : '暂无数据') }}</div>
        <div class="info-date">
          <div class="info-date-item" v-for="(dateitem,dateindex) in item.date_in_weeks" :key="dateindex">{{dateitem.date}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    docList: {
      type: Array,
      default:()=>([])
    },
  },
  data() {
    return {
      list:{},
    }
  },
  created() {
    console.log('this.listData',this.listData);
  },
  computed: {
    listData() {
        return this.docList
      }
  },
  methods: {
    // setData(){
    //   this.listData = [...this.docList]
    // },
    truncateRichText(text) {
      if (!text) {
        return
      }
      const parser = new DOMParser()
      const htmlDoc = parser.parseFromString(text, 'text/html')
      const texts = htmlDoc.body.textContent
      return texts
    },
    itemClick(item){
      this.$emit('itemClick', item)
    }
  }
}
</script>

<style scoped lang="less">
.doc-list{
  .doc-list-item{
    padding: 0.4rem 0.6rem 0.2rem;
    border-bottom: 1px solid #F5F5F5;
    // padding: 0.3rem;

    display: flex;
    gap: 0.4rem;
    .doc_avatar {
        flex-shrink: 0;
        display: inline-block;
        border-radius: 50%;
        width: 1.33rem;
        height: 1.33rem;
        overflow: hidden;
        z-index: 2;
        vertical-align: middle;
        img {
          width: 1.33rem;
        }
      }
    .info-box{
      flex-grow:1;
      display: flex;
      flex-direction: column;
      .info-box-top{
        display: flex;
        justify-content: space-between;
        .info-name{
          font-size: 0.46rem;
        }
        .info-status{
          border: 1px solid #35b6a4;
          padding: 0.05rem 0.15rem;
          color: #35b6a4;
          border-radius: 0.15rem;
          font-size: 0.32rem;
        }
      }
      .info-title{
        color: #81879C;
      }
      .info-sc{
        color: #81879C;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .info-date{
        display: flex;
        overflow: hidden;
        .info-date-item{
          margin-top: 0.2rem;
          color: #35b6a4;
          font-size: 0.32rem;
          border: 1px solid #8cd9af;
          border-radius: 50px;
          margin-right: 2%;
          padding: 2px 0;
          text-align: center;
          width: 1.2rem;
          display: inline-block;
        }
      }
    }
  }
}
</style>
  